import { Component } from '@angular/core';
import 'moment/locale/id';
import * as moment from 'moment';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { ExportDataTableService } from '../../../libraries/export/export-data-table.service';
import { AuthenticationService } from '../../../libraries/auth/authentication.service';
import { DashboardRestService } from '../dashboard-rest.service';
import { formatRupiah } from '../../../shared/utils';

@Component({
  selector: 'app-withdraw-approval-table',
  templateUrl: 'withdraw-approval-table.component.html'
})
export class WithdrawApprovalTableComponent extends BaseListBComponent<any> {
  formatRupiah = formatRupiah;

  tableColumns = [
    {
      i18nLabel: 'ui.dashboard.entity.no',
      field: 'no',
      name: 'No',
      sort: true // kalau bisa sort
    },
    {
      i18nLabel: 'ui.dashboard.entity.refNumber',
      field: 'referenceNumber',
      name: '',
      sort: true // kalau bisa sort
    },
    {
      i18nLabel: 'ui.dashboard.entity.status',
      field: '',
      name: 'status',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.category',
      field: '',
      name: 'category',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.detail',
      field: '',
      name: 'detail',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.dealer',
      field: '',
      name: 'dealer',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.transactionDate',
      field: 'createdAt',
      name: '',
      sort: false
    },
    {
      i18nLabel: 'ui.dashboard.entity.paidDate',
      field: 'paidDate',
      name: '',
      sort: false
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);
  isLoadingExportExcel: boolean = false;

  constructor(
    public _authentication: AuthenticationService,
    private _DashboardRest: DashboardRestService,
    private _export: ExportDataTableService
  ) {
    super();
    this.componentId = 'TransactionHistoryTableComponent';
    this.qParams.transactionType = '';
    this.qParams.category = '';
    // this.headerTitle = 'ui.gojekSwadaya.list.title';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        return this._DashboardRest.getWithdrawList(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map(d => {
              d.createdAt = d.createdAt ? moment(d?.createdAt).format('DD MMMM YYYY HH:mm') : '-';
              d.updatedAt = d.updatedAt ? moment(d?.updatedAt).format('DD MMMM YYYY HH:mm') : '-';
              d.paidDate = d.paidDate ? moment(d?.paidDate).format('DD MMMM YYYY HH:mm') : '-';
              return d;
            });
            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () => this.page.compHookService?.callMultipleHooks(['TransactionHistoryTableComponent:workflowLoadData'])
    });
  }

  typeOption = [
    {
      text: 'Semua Tipe Transaksi',
      value: ''
    },
    {
      text: 'Debit',
      value: 'debit'
    },
    {
      text: 'Credit',
      value: 'credit'
    }
  ];

  categoryOption = [
    {
      text: 'Semua Kategori Transaksi',
      value: ''
    },
    {
      text: 'Top-Up',
      value: '665f1a1f0f1c000001a1a001'
    },
    {
      text: 'Withdraw',
      value: '665f1a1f0f1c000001a1a003'
    },
    {
      text: 'Profit Sharing',
      value: '665f1a1f0f1c000001a1a002'
    }
  ];

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }

  mapCategory(category: string): string {
    const categoryMap: Record<string, string> = {
      TOP_UP: 'Top Up',
      WITHDRAW: 'Withdraw',
      PROFIT_SHARING: 'Profit Sharing'
    };

    return categoryMap[category] ?? 'Default';
  }

  getStatusColor(status: string) {
    if (!status) return 'warning';

    const normalizedStatus = status.toLowerCase();

    if (normalizedStatus == 'pending') return 'warning';
    if (normalizedStatus == 'success') return 'success';
    if (normalizedStatus == 'rejected') return 'danger';
  }

  // TODO: Update
  async onDownloadExcel() {
    this.isLoadingExportExcel = true;
    try {
      const result = await this._DashboardRest.getWithdrawList({}).toPromise();
      const mapOption = {
        referenceNumber: { header: 'Reference Number' },
        status: { header: 'Status' },
        category: { header: 'Category' },
        detail: { header: 'Detail' },
        dealer: { header: 'Dealer' },
        createdAt: { header: 'Transaction Date' },
        paidDate: { header: 'Paid Date' }
      };
      const payload = result.data.map((item, index) => ({
        no: index + 1,
        referenceNumber: item?.referenceNumber || '-',
        status: item?.status || '-',
        category: this.mapCategory(item?.category) || '-',
        detail: item?.detail || '-',
        dealer: item?.dealer || '-',
        createdAt: item?.createdAt ? moment(item?.createdAt).format('DD MMMM YYYY HH:mm') : '-',
        paidDate: item?.paidDate ? moment(item?.paidDate).format('DD MMMM YYYY HH:mm') : '-'
      }));
      this._export.export({
        extension: 'xlsx',
        fileName: 'WithdrawApproval',
        records: payload,
        mapOptions: mapOption,
        templateData: null,
        pdfOptions: null
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoadingExportExcel = false;
    }
  }

  // Method to refresh the table data after withdraw approval
  refreshTableData() {
    this.onGridChange();
  }
}
